export enum REGEX_TYPES {
  NAME = 'NAME',
  ID = 'ID',
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
}
